import axios from  'axios'
import { createBrowserHistory } from 'history'
import {baseUrl} from "../config/Config";
import {getOrg, getSys, getUser} from "./Storage";

const history = createBrowserHistory()

const instance=axios.create({
    withCredentials: true,
    baseURL:baseUrl,
    timeout: 10000,
});



// 添加请求拦截器
instance.interceptors.request.use(function (config) {

    // 在发送请求之前做些什么

    let user=getUser();

    if(user){
        config.headers.userId=user.id;
        config.headers.token=user.session.token;
    }

    let sys=getSys();

    if(sys){
        config.headers.sysId=sys.id;
    }

    let org=getOrg();

    if(org){
        config.headers.orgId=org.id;
    }

    console.log("请求配置",config)

    return config;

}, function (error) {
    console.log("请求出错",error)
    // 对请求错误做些什么
    //return Promise.reject(error);
    return {data:{status:-1,message:'网络出错，请稍候再试'}}
});

// 添加响应拦截器
instance.interceptors.response.use(function (response) {

    console.log("响应数据",response);

    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么

    if(response.data.status===3){
        // 用户身份过期 重新登录
        console.log("用户身份过期 重新登录");
        history.push(history.location.pathname.startsWith('/admin')?"/admin/login":"/login")
        history.go();
    }

    return response;
}, function (error) {
    console.log("响应错误",error);
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么
    //return Promise.reject(error);
    return {data:{status:-1,message:'网络出错，请稍候再试'}}
});

export default instance;